import React, { useMemo } from "react";
import { Box } from "@mui/material";
import "./styles/ListAttachments.scss";
import AttachmentRow from "../../views/Activities/AttachmentRow/AttachmentRow";

const AttachmentsList = ({
  files,
  toggleActiveCheckBox,
  toggleActiveVersionCheckBox,
  contentFormat,
}) => {
  const visibleFiles = useMemo(
    () =>
      files?.filter((file) => file?.parent?.fileId && file?.parent?.fileName) ??
      [],
    [files]
  );

  return (
    <Box component="div" className="attachmentsList">
      <Box component="ul" className="attachmentsHeader">
        <Box component="li" className="type">
          Tipo
        </Box>
        <Box component="li" className="version">
          Versão
        </Box>
        <Box component="li" className="file">
          Arquivo
        </Box>
        <Box component="li" className="receivedAt">
          Recebido Em
        </Box>
        <Box component="li" />
      </Box>

      {visibleFiles.map((file, index) => (
        <AttachmentRow
          key={index}
          file={file}
          index={index}
          format={contentFormat}
          onToggleParent={toggleActiveCheckBox}
          onToggleVersion={toggleActiveVersionCheckBox}
        />
      ))}
    </Box>
  );
};

export default AttachmentsList;
